module.exports = __webpack_public_path__ + "img/1011.9df07eee.jpg";